<app-maintenance-window />
<div class="w-full min-h-dvh page" [attr.data-theme]="theme()">
  <router-outlet></router-outlet>
</div>
